
        <app-avis-initial-type id="step1" [uid]="getUid()" [parentForm]="parentForm" [avisInitial]="avisInitial" [disabled]="disabled">
        </app-avis-initial-type>

